export default "__VITE_ASSET__D8xYmO3h__"